import config from "../Config/config";

const fetchUnits = async (setUnits) => {
  await fetch(`${config.serverBaseUrl}/unit`, { credentials: "include" })
    .then((res) => res.json())
    .then((resJson) => setUnits(resJson.data.units));
};

const saveUnit = async (
  selectedUnit,
  units,
  setIsEditing,
  setAlert,
  setUnits
) => {
  const method = selectedUnit.unit_id ? "PUT" : "POST";
  const url = selectedUnit.unit_id
    ? `${config.serverBaseUrl}/unit/${selectedUnit.unit_id}`
    : `${config.serverBaseUrl}/unit`;

  const parentUnit =
    selectedUnit.parent_unit_code &&
    units.find((u) => u.unit_code === selectedUnit.parent_unit_code);

  const approvers = selectedUnit.approvers.map((a, i) => ({
    ...a,
    approver_order: i,
  }));

  const payload = {
    ...selectedUnit,
    approvers: approvers,
    parent_unit_id: parentUnit ? parentUnit.unit_id : null,
  };
  delete payload.parent_unit_code;

  try {
    const response = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      setIsEditing(false);
      fetchUnits(setUnits);
      setAlert({
        severity: "success",
        message: `Unit saved!`,
      });
    } else {
      const data = await response.json();
      const error =
        data.errors?.[0]?.message ?? data.message ?? "Unknown error";
      setAlert({
        severity: "error",
        message: `Failed to save the unit: ${error}`,
      });
    }
  } catch (error) {
    setAlert({
      severity: "error",
      message: `Error saving the unit: ${error}`,
    });
  }
};

const deleteUnit = async (id, setUnits, setAlert) => {
  const confirm = window.confirm("Delete this unit?");
  if (!confirm) return;
  const response = await fetch(`${config.serverBaseUrl}/unit/${id}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (response.ok) {
    fetchUnits(setUnits);
    setAlert({
      severity: "success",
      message: `Unit deleted!`,
    });
  } else {
    const resJson = await response.json();
    const data = resJson.data;
    const error = data.error;
    setAlert({
      severity: "error",
      message: `Failed to delete the unit: ${error}`,
    });
  }
};

export { fetchUnits, saveUnit, deleteUnit };
